import React from 'react';

const Card = ({ children, className, isdifrent }) => {
    return (
        <>
            <div className={className ? className : `max-w-screen-2xl px-6 sm:px-8 lg:px-16 mx-auto`}>
                {children}
            </div>
        </>
    )
}

export default Card;